import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ClientErrorReporter } from '../services/client-error-reporter.service';
import { isChunkLoadError } from '../utils/chunk-load-recovery';

/**
 * Replaces Angular's default handler (which only logs to the console): every unhandled error of the app is still
 * logged there and, in addition, reported to the backend log via {@link ClientErrorReporter}.
 * Not reported here: chunk load errors (the reload in chunk-load-recovery.ts fixes them) and HTTP errors (the
 * correlation interceptor reports 5xx with the request's correlation id; 4xx are expected business answers).
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly reporter = inject(ClientErrorReporter);

  handleError(error: unknown): void {
    console.error(error);

    if (error instanceof HttpErrorResponse || isChunkLoadError(error)) return;

    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unbekannter Fehler';
    this.reporter.report({
      kind: 'error',
      message,
      stack: error instanceof Error ? error.stack : undefined,
    });
  }
}
